// src\components\Container.jsx

import React from 'react';
import './Container.css';

// This component wraps content and provides consistent maximum width and centering
const Container = ({ children, className = '' }) => {
  return (
    <div className={`global-container ${className}`}>
      {children}
    </div>
  );
};

export default Container;